import {
  CheckboxProps,
  FormControlLabelProps,
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
  styled
} from '@mui/material'
import ChevronDown from 'assets/icons/nucleo/18px_chevron-down.svg'
import { unifiedColors } from 'styles/colors'

export const ExpandMore = styled(ChevronDown, {
  shouldForwardProp: (prop) => prop !== '$expand'
})<{ $expand: boolean }>`
  transform: ${({ $expand }) => ($expand ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
  color: ${unifiedColors.icon.default};
  margin-left: 4px;
`

export const FormControlLabel = styled((props: FormControlLabelProps) => (
  <MuiFormControlLabel
    {...props}
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      width: 'max-content',
      m: 0,
      gap: 1
    }}
  />
))``

export const Checkbox = styled((props: CheckboxProps) => (
  <MuiCheckbox
    {...props}
    sx={{
      padding: '6px',
      color: unifiedColors.icon.default,
      '&.Mui-checked:not(.Mui-disabled)': {
        color: unifiedColors.button.primary.default
      },
      '&.MuiButtonBase-root': {
        flexShrink: '0'
      }
    }}
  />
))``
